export default {
  path: 'groups/:id',
  name: 'FleetGroupView',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/FleetGroupView.vue')
}
